export const getters = {
  getIsLoading: state => {
    return state.isLoading;
  },
  getIsOn: state => {
    return state.isOn;
  },
  getIsFocus: state => {
    return state.isFocus;
  },
  getIsShowMenu: state => {
    return state.isShowMenu;
  },
  getIsShowPopup: state => {
    return state.isShowPopup;
  },
  getKeepAlive: state => state.keepAlive,

  getModalAlertComponents: state => {
    return state.modalAlertComponents;
  },
  getModalComponents: state => {
    return state.modalComponents;
  },
  getRouteLayout: state => {
    return state.routeLayout;
  },
  getKeywords(state) {
    state.keywords = JSON.parse(localStorage.getItem('keywords')) || [];
    return state.keywords;
  },
  initMovePath: state => state.initMovePath
};
